<template>
    <div class="about_menu_top  textalign_left">
        <div style="background: #fff;max-width: 1920px;margin: 0 auto;"  class="ms-controller">
            <div style="margin: 0 auto;">
                <div style="height: 9200px;background: url('https://p1.fishqc.net/FiIbwKCd9hQfY2lIKpF512ZofeTn') center center no-repeat;background-size: auto 100%;padding-top:482px;box-sizing: border-box;">
                    <div class="contain_2022_315" style="width:980px;margin:0 auto;display:block;position: relative;font-size:36px;font-family:PingFang SC;color:533727;text-align: center;">
                        <div class="newyear_title">新年伊始，小鱼亲测带着全新的跨年榜单为大家开启新的一年。各种精选科学好物，从内到外让你新年焕发新光彩！</div>
                        <div>
                            <div class="newyear_padding_82" v-for="(item,index) in productdata">
                                <img :src="item.img">
                                <div class="padding_top_58" v-for="(value,index1) in item.productType">
                                    <div class="o_title">{{value.title}}</div>
                                    <div class="newyear_desc">
                                        <div style="width:892px;margin:0 auto;">{{value.productDesc}}</div>
                                    </div>

                                    <div>
                                        <div v-for="(val,index2) in value.product" class="newyear_productbox" @click="toproductdetail(val.type,val.id)">
                                            <div class="display_flex">
                                                <div class="newyear_productImage" :style="{backgroundImage: 'url('+ val.img + ')'}">
                                                    <img src="https://p1.fishqc.net/Fq2vjrrOpUYhR8AiPs0OJ5A6Wzok" class="greenfish"  v-if="val.id !== 'sUOufi6j_cK_NwqCK8hI6g'">
                                                    <img src="https://p1.fishqc.net/FsJGtR7dXi9RI9rt1v6A8-f0ce6U" class="greenfish"  v-if="val.id == 'sUOufi6j_cK_NwqCK8hI6g'">
                                                </div>
                                                <div class="padding_left_36  display_flex flex_1 flex-direction_column justify-content_flex-justify">
                                                    <div>
                                                        <div class="newyear_productbrand" v-html="val.brand"></div>
                                                        <div class="newyear_producttitle" :class="[val.id =='T3MZc1NnmmJ6BO-pSDYTCg' ?'newyear_producttitle_s':'',val.id =='68wrN4S4Ns0KZjIjDVV3_w' ?'newyear_producttitle_l':'',val.id =='li4ioIgu8L4wYXMSzN4LYA' ?'newyear_producttitle_r':'',]" v-html="val.title" ></div>
                                                    </div>
                                                    <div>
                                                        <div class="newyear_tips">{{val.tips}}</div>
                                                        <div class="newyear_address">品牌所在地：{{val.address}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        
                       
                    </div>
                    <div style="padding-top:72px;box-sizing: border-box;text-align: center;">
                        <img src="https://p1.fishqc.net/Fq1d-GFoSbpWTJW9WtvRCsC66os6" alt="">
                    </div>
                    <div style="padding-top:46px;box-sizing: border-box;text-align: center;">
                        <img src="https://p1.fishqc.net/FktlSuCpDYZOUmFeh09qb8aVbfQW" alt="">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
.about_menu_top {
    margin: 100px auto 0;

}
.fangyicontain {
    font-size: 0;
}

.mumcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
    /*padding-top: 1937px;*/
    
}
.muntitle{
    font-size:32px;
    font-family:Songti SC;
    font-weight:900;
    color:rgba(255,255,255,1);
    line-height:43px;
    text-shadow:0px 3px 8px rgba(255,117,131,0.3);
    padding:0 20px;
    vertical-align: middle;
}

.verticalalign-middle{
    vertical-align: middle;
}

.munbox{
    width:100%;
    background:#FFF7F5;
    border-radius:24px;
    padding:0 32px 60px;
    margin-bottom: 60px;

}


.munbox:last-child{
    margin-bottom: 0px;
}
.producttype{
    display:inline-block;
    width:178px;
    height:48px;
    line-height: 48px;
    color:#fff;
    font-size:24px;
    text-align:center;
    border-bottom-left-radius:42px;
    border-bottom-right-radius:42px;
    background: -webkit-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -o-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -moz-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -ms-linear-gradient(top, rgba(254,99,72,1), rgba(255,139,119,1));
    background: -webkit-gradient(linear, 0% 100%, from(rgba(254,99,72,1)), to(rgba(255,139,119,1)));
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(254,99,72,1)), color-stop(100%,rgba(255,139,119,1)));
    background:linear-gradient(0deg,rgba(254,99,72,1),rgba(255,139,119,1));
    box-shadow: 0px 0px  8px #FFAD9D;
}

.gradient{
    background: #000000;
    background: -moz-linear-gradient(top,  #000000 0%, #ffffff 100%);
    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,#000000), color-stop(100%,#ffffff));
    background: -webkit-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -o-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: -ms-linear-gradient(top,  #000000 0%,#ffffff 100%);
    background: linear-gradient(to bottom,  #000000 0%,#ffffff 100%);
    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#000000', endColorstr='#ffffff',GradientType=0 );
}
.dec{
    padding:24px 0;
    box-sizing:border-box;
    color:#444a46;
    font-size:24px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
}

.dec-text{
    font-size:18px;
    color:#494947;
    line-height:30px;
    text-indent:3px;
    text-align:left;
    padding:20px 32px;
    background-color:#fff;
    border-radius:20px;
    position:relative;
    margin-bottom: 35px;
    
}
.tips{
    width: 174px;
    height:36px;
    line-height:36px;
    background-color:#45ccbe;
    box-sizing:border-box;
    position:absolute;
    bottom:-20px;
    right:0;
    border-bottom-right-radius:20px;
    border-top-left-radius:20px;
    text-align: center;
    
}
.tipstext{
    display:inline-block;
    font-size:24px;
    color:#fff;
    font-size:18px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(225,251,248,1);
}

.productdetailcontain{
    width: 273px;
    margin-right: 60px;
    display: inline-block;
    background-color: #fff;
    border-radius:24px;
    height: 402px;
    vertical-align: top;
    /*margin-bottom: 32px;*/
    cursor: pointer;
    padding:0 40px 0;
    box-sizing: border-box;
    box-shadow: 0px 0px 24px rgba(255,117,131,0.06);

}
.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
}

.productdetailcontain:nth-of-type(3n){
    margin-right: 0px;
}

.imgcontain{
    width:100%;
    height: 100%;
    display: inline-block;
    text-align:center;
    position: relative;
    overflow: hidden;
}
.center{
    position:absolute;
    left:50%;
    top:50%;
    transform: translate(-50%, -50%);
}
.greenfish{
    position:absolute;
    right:14px;
    bottom:0px;
}
.class1{
    height: 130%;
    /*width:238px;*/
}
.class2{
    height: 100%;
    /*width:120px;*/
}
.class3{
    height: 100%;
    /*width:157px;*/
}
.class4{
    /*width:218px;*/
    height: 114%;
}
.class5{
    /*width:140px;*/
    height: 100%;
}
.class6{
    /*width:106px;*/
    height: 100%;
}
.class7{
    /*width:119px;*/
    height: 100%;
}
.class8{
    /*width:200px;*/
    height: 100%;
}
.class9{
    /*width:200px;*/
    height: 120%;
}
.class10{
    /*width:210px;*/
    height: 120%;
}

.class11{
    /*width:82px;*/
    height: 100%;
}
.class12{
    /*width:110px;*/
    height: 100%;

}
.class13{
    /*width:172px;*/
    height: 100%;
}
.class14{
    /*width:128px;*/
    height: 100%;
}
.class15{
    /*width:76px;*/
    height: 100%;

}
.class16{
    /*width:158px;*/
    height: 112%;
}

.flex-one{
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}
.brandcover{
    padding:20px 0 10px;
}

.band{
    
    font-size:24px;
    line-height: 26px;
    font-family:PingFang SC;
    font-weight:500;
    color:rgba(80,79,75,1);
}

/*.title{
    font-size:18px;
    line-height: 24px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(80,79,75,1);
    padding-bottom: 20px;
}*/

.detail-tips{
    padding:0 12px;
    height:30px;
    background:rgba(210,242,238,1);
    border-radius:12px 0px 12px 0px;
    font-size:16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(68,204,189,1);
    line-height: 30px;
    display:inline-block;
    text-align: center;

}
.address{
    padding-top: 16px;
    font-size:16px;
    line-height: 16px;
    font-family:PingFang SC;
    font-weight:400;
    color:rgba(121,121,121,1);
}

.techcontain{
    width: 1054px;
    margin:0 auto;
    display: block;
    text-align: center;
}
.heightclass1{
    height: 392px;
}
.heightclass2{
    height: 392px;
    margin-right:0;
}
.heightclass3{
    height: 470px;
}

.flex-container{
    display: flex;
    display: -webkit-box;
    display: -webkit-flex;
    -webkit-box-pack: justify;
    justify-content: space-between;
    -webkit-justify-content: space-between;
    height: 256px;
}

.derection-column{
    flex-direction: column;
    -webkit-flex-direction: column;
}

.display_flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
}

/*.display_flex > *{
     display: block;
 }*/
.display_inline-flex {
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: -webkit-inline-flex;
    display: inline-flex;
}


/*伸縮流方向*/
.flex-direction_column {
    -webkit-box-orient: vertical;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    flex-direction: column;
}

/*主軸對齊*/
.justify-content_flex-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
}

.justify-content_flex-end {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
}

.justify-content_flex-justify {
    -webkit-box-pack: justify;
    -ms-flex-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
}

/*側軸對齊*/
.align-items_flex-start {
    -webkit-box-align: start;
    -ms-flex-align: start;
    -webkit-align-items: flex-start;
    align-items: flex-start;
}

.align-items_flex-end {
    -webkit-box-align: end;
    -ms-flex-align: end;
    -webkit-align-items: flex-end;
    align-items: flex-end;
}

.align-items_center {
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
}

.align-items_baseline {
    -webkit-box-align: baseline;
    -ms-flex-align: baseline;
    -webkit-align-items: baseline;
    align-items: baseline;
}

.align-items_space_between {
    -webkit-box-align: space-between;
    -ms-flex-align: space-between;
    -webkit-align-items: space-between;
    align-items: space-between;
}

.horizontal-between {
    justify-content: space-between;
    -webkit-justify-content: space-between;
}

/*伸縮性*/
.flex_auto {
    -webkit-box-flex: 1;
    -ms-flex: auto;
    -webkit-flex: auto;
    flex: auto;
}

.flex_1 {
    width: 0;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    -webkit-flex: 1;
    flex: 1;
}

.flex_2 {
    width: 0;
    -webkit-box-flex: 2;
    -ms-flex: 2;
    -webkit-flex: 2;
    flex: 2;
}


.flex-wrap_wrap {
    flex-wrap: wrap;
}
.padding-top-495 {
    padding-top: 495px;
}

.double11_head {
    width: 1000px;
    box-sizing: border-box;
    font-size: 26px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FEAE50;
    line-height: 48px;

    background-color: #fff;
    text-align: center;
    letter-spacing: 2px;
    position: relative;
    z-index: 2;
    margin: 0 auto;
}

.double11_back {
    content: '';
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0);
    width: 958px;
    height: 70px;
    background-image: url('http://p1.fishqc.net/Fnbl0MTCI_lcZufbh51TuOICg5-u');
    background-repeat: no-repeat;
    background-position: center center;

}

.font-weight-bold {
    font-weight: bold;


}

.padding-top-46 {
    padding-top: 46px;
    text-align: center;
}

.double11_desc1 {
    padding-top: 14px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #FFFFFF;
}

.double11_bg {
    width: 1078px;
    background-image: url('http://p1.fishqc.net/FrSI1Mebdl0WDMyxfdhmR0g89YMC');
    background-position: center center;
    background-repeat: no-repeat;
    background-size: contain;
}

.double11_list {
    width: 1000px;
    margin-top: 82px;
    background-color: #fff;
    padding: 26px 30px 50px;
    box-sizing: border-box;
    z-index: 2;
    display: inline-block;
    position: relative;
}

.shadow-bottom {
    position: absolute;
    bottom: 30px;
    left: 0;
    z-index: 1
}

.double11_txt {
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #544F4D;
    text-align: center;
    line-height: 48px;
    text-align: left;
}

.double11_item {
    width: 454px;
    height: 161px;
    background: #FFFFFF;
    border: 1px solid #EEEAF0;
    margin-right: 27px;
    display: inline-block;
    margin-top: 20px;
    cursor: pointer;
}

.double11_item:nth-of-type(2n) {
    margin-right: 0;
}

.double11_item:nth-of-type(1) {
    margin-top: 6px;
}

.double11_item:nth-of-type(2) {
    margin-top: 6px;
}

.double11_list2 {
    margin-top: 92px;
    line-height: 48px;
    text-align: left;
}

.double11_list2 .double11_txt {
    text-align: left
}

.padding-top-110 {
    padding-top: 110px;
    text-align: center;
}

.double11_item_left {
    width: 160px;
    height: 100%;
    position: relative;
    display: inline-block;
    vertical-align: top;
}

.double11_item_left .productimg {
    width: 140px;
    position: absolute;
    left: 40%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.double11_item_right {
    width: 280px;
    height: 100%;
    display: inline-block;
    position: relative;
    padding-right: 20px;
    box-sizing: border-box;

}

.double11_item_right .title {
    padding-top: 25px;
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 400;
    color: #3F3E3A;
    line-height: 30px;
    padding-bottom: 18px;
    text-align: left;
}

.double11_address {

    font-size: 17px;
    font-family: Source Han Sans SC;
    font-weight: 300;
    color: #666666;
    line-height: 17px;
}

.double11_label {
    width: 98px;
    height: 30px;
    background: #FDF2E3;
    text-align: center;
    line-height: 30px;

    font-size: 17px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #FEAE82;
}

.greenfish {
    width: 64px;
    height: 64px;
    position: absolute;
    bottom: 10px;
    right: 10px;
}

.double_top_title {
    position: absolute;
    top: -52px;
    left: 50%;
    transform: translate(-50%, 0);
}
/**/
.descbox{
    height: 138px;
    background: #FFFFFF;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 44px;
    padding: 24px 130px 0 100px;
    box-sizing: border-box;
    text-align: left;
}

.padding_top_60{
    padding-top: 60px;
    box-sizing: border-box;
}

.typeItem{
    height: 138px;
    background: #355CD0;
    box-shadow: 0px 0px 6px 4px #93eee0;
    border-radius: 24px;
    font-size: 24px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #FEFFFF;
    line-height: 44px;
    text-align: left;
    padding:24px 116px 0 102px;
    box-sizing: border-box;
    position: relative;
}
.typeItem_bg{
    position: absolute;
    width:1116px;
    height: 121px;
    background: url('http://p1.fishqc.net/FgzbpmuZst-kw-yHrPcfK94rVFyt');
    background-size: contain;
    background-repeat: no-repeat;
    left: -56px;
    top: -78px;
}
    
.productItem_315{
    background: #EDFFFC;
    box-shadow: 0px 0px 8px 1px rgba(83, 116, 215, 0.29);
    border-radius: 24px;
    position: relative;
    margin-top: 78px;
    padding-top:52px;
    box-sizing: border-box;
    box-shadow: 0px 0px 12px 20px #24409314;
}

.productItem_type_title{
    width: 335px;
    height: 62px;
    background-image: url('http://p1.fishqc.net/FsFAr9gnZ3fl22TIaTazjL7T3LRS');
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
    line-height: 62px;
    text-align: center;
    position: absolute;
    left:50%;
    top:-31px;
    transform: translate(-50%,0);
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: 800;
    color: #3844BA;
}

.productItem_type_desc{
    width: 936px;
    margin:0 auto 30px;
    background: #FFFFFF;
    box-shadow: 0px 0px 9px 0px rgba(115, 228, 209, 0.21);
    border-radius: 16px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 30px;
    padding:18px 32px 14px;
    box-sizing: border-box;
    text-align: left;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_product{
    width: 454px;
    height: 254px;
    background: #FFFFFF;
    box-shadow: 0px 1px 8px 0px rgba(205, 247, 218, 0.7);
    border-radius: 24px;
    cursor: pointer;
    box-shadow: 0px 0px 12px 5px #73e4d12e;
}

.double12_producttxt{
    font-size: 20px;
    font-family: Source Han Sans SC;
    font-weight: 500;
    color: #58BA96;
    text-align: left;
    padding-top: 40px;
    box-sizing: border-box;

    font-size: 24px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #3844BA;
    line-height: 26px;
}

.double12_address{

    font-size: 16px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    line-height: 43px;
}

.double12_img{
    width: 154px;
    width: 200px;
    height: 254px;
    background-size: contain;
    background-repeat: no-repeat;
    position: relative;

}
.tips_padding{
    padding-top: 50px;
    padding-bottom: 24px;
    box-sizing: border-box;
}
.double12_tips{
    line-height: 16px;
    font-size: 16px;
    font-family: Adobe Heiti Std;
    font-weight: normal;
    color: #44CCBD;
    padding:6px 14px;
    box-sizing: border-box;
    background: #D2F2EE;
    opacity: 0.7;
    border-radius: 16px 0px 16px 0px;
    
}

.decclass{
    width: 880px;
}
.decclass1{
    width: 660px;
}
.greenfish{
    width: 88px;
    height: 88px;
    position: absolute;
    bottom: 24px;
    right: 0px;

}
.producttxt_name{
    font-size: 18px;
    line-height: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #3844BA;
    padding-top: 10px;
    box-sizing: border-box;
}

.product_img{
    width: 154px;
    height: 205px;
    margin-top: 30px;
    margin-left:20px;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
}

/*315*/
.contain_2022_315{
    .title_315{
        width: 1048px;
        font-size: 34px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
        padding-bottom: 90px;
        box-sizing: border-box;
    }

    .productcontain_315{
        width: 1128px;
        height: 591px;
        background: url('https://p1.fishqc.net/FpKU6ZUcyOBY9RJtdrIb6kpdC5RV') center center no-repeat;
        background-size: contain;
        padding: 0 34px;
        box-sizing: border-box;
    }

    .subtitle_315{
        padding-top: 48px;
        box-sizing: border-box;
        width: 1028px;
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 56px;
        margin: 0 auto;
    }

    .box_paddingtop{
        padding-top:64px;
        box-sizing: border-box;
        &:first-child{
            padding-top: 0;
        }
    }

    .title_3{
        font-size: 30px;
        font-family: PingFang SC;
        font-weight: 800;
        color: #FEFEFE;
        line-height: 70px;
        text-shadow: 1px 2px 3px #76AFC4;
        padding-top: 34px;
        box-sizing: border-box;
    }

    .producttype_desc{
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 44px;
        padding: 30px 30px 0px;
        box-sizing: border-box;
    }

    .productbox_315{
        width: 516px;
        height: 270px;
        background: #FFFFFF;
        border-radius: 24px;
        cursor: pointer;
        &.color1{
              background-color: #BFE8FD;
          }
          &.color2{
              background-color:#C9E6FB;
          }
          &.color3{
              background-color:#DEEAF9;
          }
          &.color4{
              background-color:#DEE0EF;
          }
          &.color5{
              background-color:#E8E4F1;
          }
          &.color6{
              background-color:#E9DFED;
          }
          &.height1{
            height: 294px;
          }
    }

    .padding_30_315{
        padding: 26px 30px;
        box-sizing: border-box;
    }
    .productImg{
        width: 278px;
        height: 100%;
        background-position: center center;
        background-size: 90%;
        background-repeat: no-repeat;
        position: relative;
        padding-left: 30px;
        box-sizing: border-box;
        .center{
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 30px;
        }
    }
    .productimage{

        background-position: center center;
        background-size: contain;
        background-repeat: no-repeat;
       
        
    }

    .brand_315{
        font-size: 24px;
        font-family: PingFang-SC-Medium;
        font-weight: 500;
        font-weight: 500;
        color: #504F4B;
        line-height: 24px;
        margin-top: 56px;
        box-sizing: border-box;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &.lineheight1{
            line-height: 28px;
        }
    }
    .producttitle_315{
        font-size: 18px;
        font-family: PingFang-SC-Regular;
        font-weight: 400;
        color: #504F4B;
        line-height: 18px;
        margin-top: 8px;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        &.lineheight2{
            line-height: 22px;
        }
    }
    .tips_315{
        /*line-height: 16px;
        font-size: 16px;
        font-family: Adobe Heiti Std;
        font-weight: normal;
        background-color: #FFFCA0;
        padding:6px 14px;
        box-sizing: border-box;
        color: #FF7E00;
        opacity: 0.7;*/
        /*border-radius: 16px 0px 16px 0px;*/
        display: inline-block;
        height: 30px;
        line-height: 30px;
        background: linear-gradient(-90deg, #FFFBDB, #FDE9EC);
        border-radius: 15px 0px 15px 0px;
        padding: 0 15px;
        box-sizing: border-box;
        
    }
    .tips_text{
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #FFFFFF;

        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }
    .address_315{
        margin-top: 12px;
        box-sizing: border-box;
        
        line-height: 16px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #797979;

        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }

    .greenIcon{
        width: 88px;
        height: 88px;
        position: absolute;
        bottom:36px;
        right: 28px;
    }
}

.title_618{
    width: 1030px;
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 56px;

    background: linear-gradient(175deg, #2246BE 19.62890625%, #0771D2 72.8759765625%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    margin: 0 auto;
}

.top_box{
    width: 1056px;
    background: linear-gradient(-45deg, #78AFDC, #8DB7E9);
    box-shadow: 0px 8px 6px 1px rgba(34, 100, 174, 0.05);
    border-radius: 20px;
    display: inline-block;
    margin: 0 auto;
    position: relative;
}
.top_box_title{
    height: 62px;
    line-height: 62px;
    background: linear-gradient(-90deg, #FFFBDB, #FDE9EC);
    border-radius: 0px 0px 50px 50px;
    display: inline-block;
    padding: 0 54px;
    box-sizing: border-box;
    .title{
        font-size: 32px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #FFFFFF;
        background: linear-gradient(175deg, #425CB3 19.62890625%, #237CCD 72.8759765625%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
    }
}

.top_box_desc{
    width: 970px;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 48px;
    margin: 0 auto;
    text-align: left;
    padding: 26px 0 20px;
    box-sizing: border-box;
}

.padding_134{
    padding-top: 134px;
    box-sizing: border-box;
}
.padding_300{
    padding-top: 300px;
    box-sizing: border-box;
}
.icon1{
    position: absolute;
    width: 252px;
    height: 56px;
    background: url('https://p1.fishqc.net/FukYv356ND4__Z_fWwOPmKQFLI0K') center center;
    background-size: contain;
    left:0 ;
    top: -56px;
}
.icon2{
    position: absolute;
    width: 252px;
    height: 56px;
    background: url('https://p1.fishqc.net/FnzP3HNDLgr4KHQY_--fIwfGUrPD') center center;
    background-size: contain;
    right:0 ;
    top: -56px;
}
.icon3{
    position: absolute;
    width: 252px;
    height: 57px;
    background: url('https://p1.fishqc.net/Fp24eiWjqtJcGZmZPdg7cpyJj9Iw') center center;
    background-size: contain;
    left:0 ;
    top: -56px;
}

.itemtitle{
    height: 50px;
    line-height: 50px;
    background: linear-gradient(-33deg, #C481A4, #347AB6);
    border-radius: 0px 30px 0px 0px;
    padding: 0 36px 0 30px;
    box-sizing: border-box;
    font-size: 28px;

font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFE;
    display: inline-block;
}

.margin_top_32{
    margin-top: 32px;
    
}
.subbox{
    width: 1056px;
    background: #FFFFFF;
    border-radius: 0px 20px 20px 20px;
    padding: 26px 32px 28px;
    box-sizing: border-box;
    font-size: 28px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #0A86CD;
    line-height: 48px;
}

.padding_top_24{
    padding-top: 24px;
    box-sizing: border-box;
}


/*

 */

.newyear_title{
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 300;
    color: #FFFEFD;
    line-height: 50px;
}

.newyear_padding_82{
    padding-top:82px;
    box-sizing: border-box;
}

.padding_top_58{
    padding-top:58px;
    box-sizing: border-box;
}

.o_title{
    width: 230px;
    height: 80px;
    background: linear-gradient(to left, #FCA6B5, #B0C7FA, #6BD4E5);
    border-radius: 40px 40px 40px 40px;
    line-height: 80px;
    text-align: center;
    font-size: 50px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    margin:0 auto;

}

.newyear_desc{
    width: 975px;
    background: #FFFFFF;
    border-radius: 24px 24px 24px 24px;
    font-size: 34px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #F17273;
    line-height: 50px;
    text-align: justify;
    margin:22px 0 54px;
    padding:44px 0;
    box-sizing: border-box;
}

.newyear_productbox{
    width: 460px;
    height: 242px;
    background: rgba(255, 255, 255, .2);
    border-radius: 24px 24px 24px 24px;
    display: inline-block;
    margin-right: 36px;
    margin-bottom: 40px;
    padding:12px 16px 12px 8px;
    box-sizing: border-box;
    cursor: pointer;
    &:nth-child(2n){
        margin-right: 0;
    }
    &:nth-child(3),&:nth-child(4){
        margin-bottom: 0;
    }

    .newyear_productImage{
        width: 152px;
        height: 217px;
        background-repeat:no-repeat;
        background-position: center center;
        background-size: contain;
        position: relative;
    }
    .padding_left_36{
        padding-left: 36px;
        box-sizing: border-box;
        padding-top: 4px;
    }

    .newyear_productbrand{
        font-size: 25px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFEFE;
        line-height: 38px;
        text-align: left;
    }
    .newyear_producttitle{
        font-size: 25px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFEFE;
        line-height: 38px;
        text-align: left;
        &.newyear_producttitle_s{
            font-size: 22px;
            line-height: 27px;
        }

        &.newyear_producttitle_l{
            line-height: 32px;
        }

        &.newyear_producttitle_r{
            font-size: 22px;
            line-height: 36px;
        }
    }


    .newyear_tips{
        width: 122px;
        height: 34px;
        line-height: 34px;
        background: linear-gradient(to left, #FCA6B5, #B0C7FA, #6BD4E5);
        border-radius: 18px 18px 18px 18px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        text-align: center;
    }

    .newyear_address{
        padding-top:10px;
        font-size: 22px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        padding-bottom:8px;
        box-sizing: border-box;
        text-align: left;
    }

    
}

.greenfish{
    width:80px;
    height: 80px;
    position: absolute;
    right: -12px;
    bottom: 0;


}
</style>
<script>
import Vue from 'vue'
// @ is an alias to /src
import banner from '@/components/banner.vue'
import { myMixin } from '@/mixin/mixin.js'
export default {
    name: 'about',
    components: {
        banner,
    },
    mixins: [myMixin],
    data() {
        return {
            productdata:[
                {
                    img:'https://p1.fishqc.net/Fp33Wi4dnZT67RnN9PV7eHdpzrDs',
                    productType:[
                        {
                            title:'精华',
                            productDesc:'干燥的冬季，除了基本的补水保湿，肌肤还需要用精华来进行更深层次的维稳和修护。选择拥有绿鱼标签的优品，用的更放心。',
                            product:[
                                {
                                    img:'https://p1.fishqc.net/FoLNCARAtAEk8uojO7ZqAcelQe1d',
                                    class:'class1',
                                    brand:'PURID朴理',
                                    title:'创研修护焕漾精华液<br>（2号精华）',
                                    tips:'抗红御氧',
                                    address:'中国',
                                    type:'cosmetic',
                                    id:'uBKKOZ0Ao5UKRKyj9CEC6g',
                                    
                                },{
                                    img:'https://p1.fishqc.net/FhjbTNbxq3NjEmDudhNgT4eYANl8',
                                    class:'class1',
                                    brand:'OLAY玉兰油',
                                    title:'纯璨晶透肌底精华露',
                                    tips:'光透亮白',
                                    address:'美国',
                                    type:'cosmetic',
                                    id:'Mga3kkvuyAkz8jNtxqoZTQ',
                                },{
                                    img:'https://p1.fishqc.net/FqGrEUW8UmBGZ47Y4H-evDjEcKvb',
                                    class:'class1',
                                    brand:"L'OREAL PARIS<br>巴黎欧莱雅",
                                    title:'复颜抗皱紧致视黄醇精粹抗皱精华',
                                    tips:'紧致焕亮',
                                    address:'法国',
                                    type:'cosmetic',
                                    id:'T3MZc1NnmmJ6BO-pSDYTCg',
                                },{
                                    img:'https://p1.fishqc.net/Fl3RlySnq9kMIE7gwxXLjj-mhsuo',
                                    class:'class1',
                                    brand:'GRASUS瑰倚丝',
                                    title:'果萃柔肤精华液',
                                    tips:'软化角质',
                                    address:'中国',
                                    type:'cosmetic',
                                    id:'g9RkjEhY_8FoisLx5_PO4Q',
                                }
                            ]
                        },{
                            title:'面膜',
                            productDesc:'除了日常使用爽肤水，我们还应该定期使用面膜来对皮肤进行深层补水保湿。使用拥有绿鱼标签的产品，为你变美之路保驾护航。',
                            product:[
                                {
                                    img:'https://p1.fishqc.net/FvJtBxvGnfnRC-tsLQTcOcLOs4zc',
                                    class:'class1',
                                    brand:'阳光新视界',
                                    title:'修护面膜',
                                    tips:'修护养颜',
                                    address:'中国',
                                    type:'cosmetic',
                                    id:'fdE-3GkTDEOKWBJG385jnw',
                                },
                                {
                                    img:'https://p1.fishqc.net/FgXEWr57otzzxiVwz7xvRDZtfmG9',
                                    class:'class1',
                                    brand:'SK-II',
                                    title:'护肤面膜 前男友面膜',
                                    tips:'水光泛亮',
                                    address:'日本',
                                    type:'cosmetic',
                                    id:'kYKQut3tj8dGzCXOT99lSQ',
                                },
                                {
                                    img:'https://p1.fishqc.net/FtahxT66Em43G7_c5RqOov2QmYMx',
                                    class:'class1',
                                    brand:'INNISFREE 悦诗风吟',
                                    title:'济州石榴活妍焕采精华密集修护面膜套装',
                                    tips:'滋养清透',
                                    address:'韩国',
                                    type:'cosmetic',
                                    id:'68wrN4S4Ns0KZjIjDVV3_w',
                                },
                                {
                                    img:'https://p1.fishqc.net/FlD1g2-gnv4yRi2VQnHNNEuQ67lU',
                                    class:'class1',
                                    brand:'La Roche-Posay<br>理肤泉',
                                    title:'B5多效保湿修复面膜',
                                    tips:'安心维稳',
                                    address:'法国',
                                    type:'cosmetic',
                                    id:'iN0jwvCNoi5RCQ9ymBmtqA',
                                }
                                
                            ],
                        },
                        {
                            title:'面霜',
                            productDesc:'面霜可以帮助皮肤锁住水分，同时补充营养物质。新年伊始，是时候选择一款适合自己肌肤需求的面霜了。',
                            product:[
                                {
                                    img:'https://p1.fishqc.net/FheUlKAkxVe5qDtG6qKN64THvVZe',
                                    class:'class1',
                                    brand:'SKINCEUTICALS<br>修丽可',
                                    title:'紧致塑颜面霜',
                                    tips:'清透塑颜',
                                    address:'美国',
                                    type:'cosmetic',
                                    id:'HcLChmVn61Jxp9fVCxFG2w',
                                },
                                {
                                    img:'https://p1.fishqc.net/Fr56wRyoaPuxssTQ_tz5pN9T6BvT',
                                    class:'class1',
                                    brand:'MyClorisLand花皙蔻',
                                    title:'菁纯牡丹抗皱淡纹精华霜',
                                    tips:'紧致淡纹',
                                    address:'中国',
                                    type:'cosmetic',
                                    id:'li4ioIgu8L4wYXMSzN4LYA',
                                },
                                {
                                    img:'https://p1.fishqc.net/Fobyx2uRA1Qp3Yc-ukrI_Xuo5bPP',
                                    class:'class1',
                                    brand:'Clé de Peau Beauté<br>肌肤之钥',
                                    title:'金致乳霜',
                                    tips:'滋养弹润',
                                    address:'日本',
                                    type:'cosmetic',
                                    id:'pvSTCcpvKrUdcPkn_4SYnA',
                                },
                                {
                                    img:'https://p1.fishqc.net/Fkc5fHHJ5F40aMV2S0tCmjCrr51R',
                                    class:'class1',
                                    brand:'ESTEE LAUDER<br>雅诗兰黛',
                                    title:'鲜活亮采晚霜',
                                    tips:'丰盈饱满',
                                    address:'美国',
                                    type:'cosmetic',
                                    id:'fF3VDWuCzV_T_Sqr70Ki4A',
                                }
                                
                            ],
                        },
                    ]
                },
                {
                    img:'https://p1.fishqc.net/FuTJ-RnhtfsymGjLMqYbbUlbxwZd',
                    productType:[
                        {
                            title:'保健品',
                            productDesc:'现代社会紧张的生活节奏，保健品可以帮助我们及时补充不同的营养需求，让身体保持在最佳状态。',
                            product:[
                                {
                                    img:'https://p1.fishqc.net/FrfpO44G0Pm0ysHdjF2Shwtr2uKZ',
                                    class:'class1',
                                    brand:'Doppelherz双心',
                                    title:'ALL IN ONE',
                                    tips:'全面养护',
                                    address:'德国',
                                    type:'food',
                                    id:'sUOufi6j_cK_NwqCK8hI6g',
                                    
                                },{
                                    img:'https://p1.fishqc.net/FvqLDFgePluqdw7m_TtKCDnZ0R8n',
                                    class:'class1',
                                    brand:'UNICHI',
                                    title:'玫瑰果精华胶囊',
                                    tips:'美白透亮',
                                    address:'澳大利亚',
                                    type:'food',
                                    id:'NlLXQsnsQmR4DzNdslEnPA',
                                },{
                                    img:'https://p1.fishqc.net/Fs6kSSlbgq0jLtL4htQMz-P4g37t',
                                    class:'class1',
                                    brand:"GNC健安喜",
                                    title:'高含量钙片1000mg',
                                    tips:'呵护健康',
                                    address:'美国',
                                    type:'food',
                                    id:'yIO8Zliupd7oMIl6hXA_yg',
                                },{
                                    img:'https://p1.fishqc.net/FglgWa7mD8XjccTvJoST5PGPLj5U',
                                    class:'class1',
                                    brand:'Blackmores 澳佳宝',
                                    title:'深海无腥味鱼油 1000',
                                    tips:'深海营养',
                                    address:'澳大利亚',
                                    type:'food',
                                    id:'SskZ10o-DwRJSBrt_EfpoQ',
                                }
                            ]
                        },{
                            title:'身体乳',
                            productDesc:'每天坚持涂抹身体乳，可以让你在干燥的冬季减少瘙痒泛红的身体皮肤问题。选择小鱼亲测精选的优品，让你用的更加安心。',
                            product:[
                                {
                                    img:'https://p1.fishqc.net/FmeNbxE-vstS6GvEkZVGjy0s1Gng',
                                    class:'class1',
                                    brand:'CeraVe',
                                    title:'长效保湿修复乳',
                                    tips:'修护补水',
                                    address:'法国',
                                    type:'cosmetic',
                                    id:'G8DSWGQVu9-PBfLpFkvDiA',
                                },
                                {
                                    img:'https://p1.fishqc.net/FrPiKwxgSP_P0hI4q6Gt4wwVe9gW',
                                    class:'class1',
                                    brand:'NIVEA 妮维雅',
                                    title:'深层润肤乳液',
                                    tips:'深层滋润',
                                    address:'德国',
                                    type:'cosmetic',
                                    id:'JfhB8OyuVkHUNEtJ_D-wPw',
                                },
                                {
                                    img:'https://p1.fishqc.net/Ft761_jxkuD4j0GhW3b7CLZNqrVA',
                                    // img:'https://p1.fishqc.net/FoyiSlkcaHs8wFvABDOWT2JCkgZw',
                                    class:'class1',
                                    brand:'AVEENO艾惟诺',
                                    title:'天然燕麦成人清爽透润肤乳',
                                    tips:'水润轻薄',
                                    address:'美国',
                                    type:'cosmetic',
                                    id:'ImGumQax8Ru6zVGkC2Xjfg',
                                },
                                {
                                    img:'https://p1.fishqc.net/Ft8bbB6Q870pVrYmWMiVmWk5E6l1',
                                    class:'class1',
                                    brand:"KIEHL'S科颜氏",
                                    title:'全身保湿护肤乳液',
                                    tips:'柔嫩细润',
                                    address:'美国',
                                    type:'cosmetic',
                                    id:'6eh2v7orZILg00rqBUpmwg',
                                }
                                
                            ],
                        }
                        
                    ]
                },
    
    
            ]
        }

    },
    computed: {
        swiper() {
            return this.$refs.order_report_Swiper.$swiper
        }
    },
    mounted() {
        // var position  =  this.$route.query.position
        // this.scrollTo(position)
        this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
    },
    methods: {
        scrollTo(position) {
            var that = this;
            var scroll_H;
            this.$nextTick(function() {
                if (position == 'greenrank') {
                    var d = document.getElementById("greenrank");
                    var topPos = d.offsetTop;
                    scroll_H = topPos - 110; //减去header高度
                } else {
                    scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
                }
                //全局方法
                that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
            })
        },
        toproductdetail(type,prdid){
            let routeUrl  =this.$router.resolve({
                path:'/product',
                // query:{
                //     type:prdid
                // }
            })

            console.log(routeUrl.href)
            // return

            window.open(routeUrl.href+'/'+type+'/'+prdid,'_blank')


            // this.$router.push({
            //     path: '/product/'+type+'/'+prdid
            // / })
            
        }
    }
}
</script>